export const VIDEO_LIST_REQUEST = 'VIDEO_LIST_REQUEST'
export const VIDEO_LIST_SUCCESS = 'VIDEO_LIST_SUCCESS'
export const VIDEO_LIST_FAIL = 'VIDEO_LIST_FAIL'
export const VIDEO_LIST_RESET = 'VIDEO_LIST_RESET'
